export class EnvironmentService {
  static getEnv(): string {
    let env = 'prod';

    try {
      const { hostname } = window.location;

      if (hostname.includes('dev') || hostname.includes('local')) {
        env = 'dev';
      } else if (hostname.includes('qa')) {
        env = 'qa';
      }
    } catch (error) {
      window.console.error(
        'Failed to check hostname for env.',
        { error }
      );
    }

    return env;
  }
}

export default EnvironmentService;
